import { createContext } from 'react'

import type { AccordionSize, AccordionVariant } from './accordion.styles'

export const SINGLE_ITEM_VALUE = 'item'

export const AccordionVariantContext = createContext<AccordionVariant>('inline')

/**
 * Kept separate from the variant context rather than merged into one
 * `{ variant, size }` value: `Root` would then hand every consumer a freshly
 * allocated object on each render. Two primitive contexts stay referentially
 * stable on their own.
 */
export const AccordionSizeContext = createContext<AccordionSize>('medium')
